import { render, staticRenderFns } from "./member_service_agreement.vue?vue&type=template&id=27df148c&scoped=true"
import script from "./member_service_agreement.vue?vue&type=script&lang=js"
export * from "./member_service_agreement.vue?vue&type=script&lang=js"
import style0 from "./member_service_agreement.vue?vue&type=style&index=0&id=27df148c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df148c",
  null
  
)

export default component.exports